import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import _ from 'lodash';

/*Dialogs*/
import PhoneNumberUpdatedOverlayDialog from '../../dialogs/phoneNumberUpdatedOverlayDialog';
import UpdateCompleteForNotificationsOverlayDialog from '../../dialogs/updateCompleteForNotificationsOverlayDialog';
import UpdateCompleteForAccountAccessRequestOverlayDialog from '../../dialogs/updateCompleteForAccountAccessRequestOverlayDialog';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';

import {
	selectAllNotificationList,
	updateNotification,
	saveUserProfile,
	sendEmailSuccessDialog,
	getUserContactPointList,
	saveUserContactPointList,
	changePhoneNumber,
	backupNotificationList,
	updateUserNotifications,
	getRoleList,
	saveRoleList,
	updateUserAccounts,
} from '../../../redux/actions';

class OtherUserMyProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
			showEmailUpdateConfirmationDialog: false,

			showUpdatePhoneNumberOverlayDialog: false,

			selectAllNotifications: false,
			showUpdatePreferencesOverlayDialog: false,
			preferencesErrorMessage: '',

			showUpdateAccountsOverlayDialog: false,
			accountsErrorMessage: '',

			phoneNumberErrorMessage: '',
			updatePhoneNumber: {
				params: {
					phoneNumber: '',
					phoneNumberDetails: null
				},
				error:{
					phoneNumberError: ''
				}
			},

			oracleEmailForm: {
				params: {
					oracleEmail: '',
				},
				error: {
					oracleEmailError: '',
				}
			},

			userDetailsEmailForm: {
				params: {
					userDetailsEmail: '',
				},
				error: {
					userDetailsEmailError: '',
				}
			},

			allAddresses: null,

			legacyPayload: null,

			notificationTypeListBkp: null,

			siteId: '',
			roleId: '',
			parallelCallCount: 0,

			isRoleListCallCompleted: false,
		};
		this.fetchRoleList = this.fetchRoleList.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.updateNotificationInStore = this.updateNotificationInStore.bind(this);
		this.showEmailConfirmation = this.showEmailConfirmation.bind(this);
		this.callBackAfterParallelCallsCompleted = this.callBackAfterParallelCallsCompleted.bind(this);
		this.callBackToUpdatePhoneNumber = this.callBackToUpdatePhoneNumber.bind(this);
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentWillMount() {
		const self = this;
		const { getUserDetailsData, userDetails } = self.props;
		let oracleEmail = '';
		if(getUserDetailsData && getUserDetailsData.length) {
			oracleEmail = getUserDetailsData[0].EMAIL_ADDRESS;
		}
		self.props.getUserContactPointList(`personPartyId=${this.props.personPartyId}&requestType=getUserContactPointList`, response => {
			if(response.status) {
				self.setState({
					getUserContactPointListData: response
				}, () => {
					self.props.saveUserContactPointList(response);
					self.callBackToUpdatePhoneNumber(response);
				});
			}
		});
		self.setState({
			oracleEmailForm: {
				params: {
					oracleEmail,
				},
				error: {
					oracleEmailError: '',
				}
			},
			userDetailsEmailForm: {
				params: {
					userDetailsEmail: userDetails.emailAddress,
				},
				error: {
					userDetailsEmailError: '',
				}
			},
		});
		self.props.selectAllNotificationList(false);
		self.fetchRoleList();
	}

	callBackToUpdatePhoneNumber(response) {
		const self = this;
		let phoneNumber = '';
		if(response.responseObject && response.responseObject.length > 0) {
			phoneNumber = _.find(response.responseObject, { 'CONTACTTYPE': 'PHONE', 'PRIMARYINDICATOR': 'Y' });
		}
		if(phoneNumber && phoneNumber.CONTACTPHONE) {
			self.setState({
				updatePhoneNumber: {
					...self.state.updatePhoneNumber,
					params: {
						...self.state.updatePhoneNumber.params,
						phoneNumber: self.normalizePhoneNumber(phoneNumber.CONTACTPHONE),
						phoneNumberDetails: phoneNumber
					}
				}
			})
		}
	}

	setValue(whichForm, fieldName, event) {
		this.setState({
			[whichForm]: {
				...this.state[whichForm],
				params: {
					...this.state[whichForm].params,
					[fieldName]: event.target.value
				},
				error: {
					...this.state[whichForm].error,
					[fieldName+"Error"]: ""
				}
			}
		})
	}

	normalizePhoneNumber(s) {
		var npa, nxx, xxxx, n;

		n = s.replace(/\D+/g, "");
		if ((/^1?([2-9]\d{2})(\d{3})(\d{4})$/).test(n)) {
			npa  = RegExp.$1;
			nxx  = RegExp.$2;
			xxxx = RegExp.$3;
			n = "(%s) %s-%s".replace(/%s/, npa).replace(/%s/, nxx).replace(/%s/, xxxx);
			return n;
		}
		return s;
	}

	isValidPhoneNumber(s) {
		if(!s) return "";
		s = s.replace(/\D+/g, "");
		return (/^1?[2-9][0-9]{9}$/).test(s);
	}

	handleUpdatePhoneNumber(event) {
		event.preventDefault();
		var self = this,
			formError = false;

		//reset messages and overlays
		self.setState({
			showUpdatePhoneNumberOverlayDialog: false,
			phoneNumberErrorMessage: ''
		});

		if(!self.isValidPhoneNumber(this.state.updatePhoneNumber.params.phoneNumber)){
			formError = true;
			self.setState({
				updatePhoneNumber:{
					...self.state.updatePhoneNumber,
					error: {
						...self.state.updatePhoneNumber.error,
						phoneNumberError: 'error'
					}
				}
			})
		}

		if(!formError) {
			const { params } = self.state.updatePhoneNumber,
				phoneNumber = params.phoneNumber.replace("(","").replace(")","").replace(" ","").replace("-","").trim(),
				personPartyId = this.props.personPartyId;

			self.props.changePhoneNumber(`requestType=updateUserPhone&personPartyId=${personPartyId}&phone=${phoneNumber}&contactPointId=${params.phoneNumberDetails.CONTACTPOINTID}`, (response) => {
				if(response.status) {
					if(response.responseObject && response.responseObject.returnstatus) {
						if(response.responseObject.returnstatus.value === 'S') {
							//Show confirmation overlay dialog
							self.setState({
								showUpdatePhoneNumberOverlayDialog: true,
								phoneNumberErrorMessage: "User's phone number has been successfully updated."
							});
						} else {
							self.setState({
								showUpdatePhoneNumberOverlayDialog: false,
								phoneNumberErrorMessage: 'Unable to update phone number'
							});
						}
					}
				} else {
					browserHistory.push('/error');
				}
			});
		}
	}

	onBlurValidatePhoneNumber(event) {
		var self = this,
			updatedParams = this.state.updatePhoneNumber;

        //Reset Error flag first
    	updatedParams.error.phoneNumberError = "";

        //Update current value
		updatedParams.params.phoneNumber = event.target.value;

		if(updatedParams.params.phoneNumber !== "" && self.isValidPhoneNumber(updatedParams.params.phoneNumber)) {
			updatedParams.error.phoneNumberError = "";
			var formattedNum = self.normalizePhoneNumber(event.target.value);
			updatedParams.params.phoneNumber = formattedNum;
			event.target.value = formattedNum;
		}

        self.setState({
            updatePhoneNumber: updatedParams
        });
	}

	handleChangeNotificationType(event) {
		this.setState({
			preferencesErrorMessage: ''
		})
		this.props.updateNotification([{notificationType: event.target.value, bool: event.target.checked}]);
	}

	handleSelectAllNotification(flag, event){
		event.preventDefault();
		const self = this;
		self.setState({
			selectAllNotifications: flag
		}, () => {
			self.props.selectAllNotificationList(self.state.selectAllNotifications);
		});
	}

	fetchRoleList() {
		const self = this;
		const { selectedAccount } = self.props.state.user,
			soldToAddresses = self.props.getAddressesByCategory('SOLD_TO');

		let	siteId = '';
		if(soldToAddresses.length > 0) {
			siteId = soldToAddresses[0].SITEID;
		}

		self.setState({
			siteId
		});

		// get role list
		const personPartyId = this.props.personPartyId,
			payload = `requestType=getRoleList&personPartyId=${personPartyId}&accountNumber=${selectedAccount.ACCOUNTNUMBER}`;
		self.props.getRoleList(payload, response => {
			if(response.status) {
				self.updateNotificationInStore(response);
			} else {
				browserHistory.push('/error');
			}
		});
	}

	updateNotificationInStore(roleList) {
		const self = this;
		const updatedNotifications = [];
		const maxRoleIdRecord = _.maxBy(roleList.responseObject, 'ROLEID');
		const roleId = maxRoleIdRecord && maxRoleIdRecord.ROLEID;

		roleList.responseObject = roleList.responseObject.filter(itm => itm.ROLEID === roleId);
		self.props.state.user.notificationTypeList.forEach(itm => {
			const data = roleList.responseObject.filter(it => it.ROLENAME === itm.shortValue);
			if(data.length > 0) {
				updatedNotifications.push({
					notificationType: itm.value,
					bool: true,
				});
			} else {
				updatedNotifications.push({
					notificationType: itm.value,
					bool: false,
				});
			}
		});
		self.props.updateNotification(updatedNotifications);
		// Backup notificationList to compare later on
		self.props.backupNotificationList();
		self.setState({
			isRoleListCallCompleted: true,
			roleId
		});
	}

	isResponsibilityExists(responsibilityToCheck) {
		const self = this;
		const { selectedAccount } = self.props.state.user;
		const { userDetails } = self.props;
		let responsibilityThere = false;
		if(selectedAccount && userDetails && userDetails.accounts) {
			const data = userDetails.accounts.find(itm => itm.accountNumber === selectedAccount.ACCOUNTNUMBER);
			if(data && data.responsibilities && data.responsibilities.indexOf(responsibilityToCheck) !== -1) {
				return true;
			}
		}
		return responsibilityThere;
	}

	handleUpdateNotifications(event) {
		event.preventDefault();
		const updatedNotifications = [],
			self = this;
		const {
			notificationTypeListBkp,
			notificationTypeList,
			unCheckNotificationMapping,
			roleList
		} = self.props.state.user;
		let anyChangeMade = false;
		const isPricingAccess = this.isResponsibilityExists("Price");
		notificationTypeListBkp.forEach((item, index) => {
			if(item.checked !== notificationTypeList[index].checked) {
				anyChangeMade = true;
				// Need to pass only changed values in payload
				const mappingData = unCheckNotificationMapping.find(itm => itm.notification === item.shortValue);

				const checked = notificationTypeList[index].checked;
				let responsibilityId = '';
				const data = roleList.responseObject.find(it => (it.ROLENAME === mappingData.value || it.ROLENAME === mappingData.notification));
				if(data) {
					responsibilityId = data.RESPONSIBILITYID;
				}
				let notification = mappingData.notification;
				if(isPricingAccess && notification === "ORDER ACKNOWLEDGEMENT WO PRICE") {
					notification = "ORDER ACKNOWLEDGEMENT W PRICE";
				}
				updatedNotifications.push({
					name: checked ? notification : mappingData.value,
					selected: checked ? "Y" : "N",
					responsibilityId,
				});
			}
		})

		if(!anyChangeMade) {
			//reset messages and overlays
			self.setState({
				preferencesErrorMessage: 'Change your preferences to update'
			});
			return;
		}

		//reset messages and overlays
		self.setState({
			showUpdatePreferencesOverlayDialog: false,
			preferencesErrorMessage: '',
			updatedNotifications,
		}, () => {
			// self.getContactPartyId();
			self.callBackAfterParallelCallsCompleted();
		});
	}

	callBackAfterParallelCallsCompleted() {
		const self = this;
		const {
			isRoleListCallCompleted
		} = self.state;
		if(isRoleListCallCompleted) {
			self.props.updateUserNotifications(self.state.updatedNotifications, `requestType=updateUserNotifications&roleId=${self.state.roleId}`, response => {
				if(response.status) {
					// response.responseObject = response.responseObject && response.responseObject.filter(itm => itm.selected === "Y");
					const errorOccured = !response.responseObject || (response.responseObject && _.find(response.responseObject, ['updateSuccessful', false]))?true:false
					if(!errorOccured) {
						// Manipulate store with latest role list id and data so that no need to make get role list required again
						let roleList = JSON.parse(JSON.stringify(self.props.state.user.roleList));
						const {
							unCheckNotificationMapping
						} = self.props.state.user;
						response.responseObject.forEach(itm => {
							// if item is selected
							if(itm.selected === 'Y') {
								const mappingData = unCheckNotificationMapping.find(role => role.notification === itm.name);
								// Check if already dummy mapping is there or not
								const index = _.findIndex(roleList.responseObject, role => role.ROLENAME === mappingData.value);
								if(index !== -1) {
									roleList.responseObject[index].ROLENAME = itm.name;
								} else {
									roleList.responseObject.push({
										RESPONSIBILITYID: itm.responsibilityId,
										ROLEID: roleList.responseObject.length > 0 && roleList.responseObject[0].ROLEID,
										ROLENAME: itm.name,
										STATUS: "A"
									});
								}
							} else { // else if item is deselected
								const mappingData = unCheckNotificationMapping.find(role => role.value === itm.name);
								// Check if already original entry there or not
								const index = _.findIndex(roleList.responseObject, role => role.ROLENAME === mappingData.notification);
								if(index !== -1) {
									roleList.responseObject[index].ROLENAME = itm.name;
								}
							}
						});
						self.props.saveRoleList(roleList);

						self.setState({
							showUpdatePreferencesOverlayDialog: errorOccured?false:true,
							preferencesErrorMessage: errorOccured?'Update notification was not successful':"User's notification preferences have been successfully updated."
						});

						self.props.backupNotificationList();
					}
				} else {
					browserHistory.push('/error')
				}
			});
		}
	}

	onChangeUpdateParam(formName, event) {
        const self = this;
		const name = event.target.name,
			value = event.target.value;
        self.setState({
			[formName]: {
				...self.state[formName],
				params: {
					...self.state[formName].params,
					[name]: value
				}
			}
        }, () => {
			if(self.state[formName].error[name+"Error"]) {
				self.setState({
					[formName]: {
						...self.state[formName],
						error: {
							...self.state[formName].error,
							[name+"Error"]: ""
						}
					}
		        });
			}
		});
    }

	validateEmail(emails) {
        var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
        emails = emails.split(',');
        for (var i = 0; i < emails.length; i++) {
            if(emails[i].trim() !== "" && !emails[i].trim().match(re)) {
                return false;
            }
        }
        return true;
    }

	handleUpdate(formName, selecevent) {
		event.preventDefault();
		const self = this,
            params = self.state[formName].params,
			error = self.state[formName].error;
        let formError = false;

        for(var key in error) {
            if(params[key.replace("Error","")] === "" || !self.validateEmail(params[key.replace("Error","")])) {
                error[key] = 'error';
                formError = true;
            } else {
				error[key] = '';
			}
        }

		self.setState({
			[formName]: {
				params,
				error
			}
		});
		if(!formError) {
			const { userDetails } = self.props;
			if(formName === 'userDetailsEmailForm') {
				self.props.updateUserAccounts({}, `requestType=updateUserCNetEmail&userId=${userDetails.userId}&emailId=${params.userDetailsEmail}`, response => {
					if(response.status) {
						self.props.updateUsersOfAccountData(self.state.userDetailsEmailForm.params.userDetailsEmail);
						self.showEmailConfirmation('Email has been updated successfully.');
					} else {
						browserHistory.push("/error");
					}
				});
			} else {
				self.props.updateUserAccounts({}, `requestType=updateUserEBSEmail&userId=${userDetails.userId}&emailId=${params.oracleEmail}`, response => {
					if(response.status && response.responseObject) {
						self.setState({
							updateUserEBSEmailCompleted: true,
						}, () => {
							self.checkParallelCallsCompleted();
						});
					} else {
						browserHistory.push("/error");
					}
				});
				const { getUserContactPointListData } = self.state;
				let data = '';
				if(getUserContactPointListData.responseObject && getUserContactPointListData.responseObject.length > 0) {
					data = _.find(getUserContactPointListData.responseObject, { 'CONTACTTYPE': 'EMAIL', 'PRIMARYINDICATOR': 'Y' });
					data = data ? data.CONTACTPOINTID : '';
				}
				self.props.changePhoneNumber(`requestType=updateUserOracleEmail&emailId=${params.oracleEmail}&contactPointId=${data}`, (response) => {
					if(response.status && response.responseObject) {
						self.setState({
							updateUserOracleEmailCompleted: true
						}, () => {
							self.checkParallelCallsCompleted();
						});
					} else {
						browserHistory.push('/error');
					}
				});
			}
		}
	}

	checkParallelCallsCompleted() {
		const self = this;
		const {
			updateUserEBSEmailCompleted,
			updateUserOracleEmailCompleted,
		} = self.state;
		if(updateUserEBSEmailCompleted && updateUserOracleEmailCompleted) {
			self.showEmailConfirmation('Email has been updated successfully.');
		}
	}

	showEmailConfirmation(msg) {
		const self = this;
		self.setState({
			genericDialogHeading: 'Success',
			genericDialogText: msg,
			modalButtons: 'ok',
		}, () => {
			self.handleDialog('EmailUpdateConfirmationDialog', true, null);
		});
	}

    render() {
		const { userDetails, ldapEmail, isAdmin, typeOfAccount } = this.props;
		const approvedAccounts = userDetails.accounts;
		const isPricingAccess = this.isResponsibilityExists("Price");
		const isCreateOrderAccess = this.isResponsibilityExists("Create Order");
		const isEditOrderAccess = this.isResponsibilityExists("Edit Orders");
		const isPriceDiscountAccess = this.isResponsibilityExists("Price Discounts");
		const isViewOrderAccess = this.isResponsibilityExists("View Order");
		const isThisAccountRestricted = this.props.isThisAccountRestricted;
        return (
			<div>
				{userDetails?
					<div className="columns twoColumns">
			        	<div className={"column noInnerTopMargin "+(!isThisAccountRestricted?"strokeRight":"")}>
							<div className="largePush">
								<p>
									<strong>User Name:</strong> {userDetails.userId}<br />
									<strong>Emails of record</strong><br/>
									<table className="updateOtherEmailAddressTable" width="100%">
										<tr>
											<td className="column1">LDAP email</td>
											<td className="column2">{ldapEmail}</td>
											<td className="column3"></td>
											<td className="column4">{!isAdmin && <strong>SN ticket required</strong>}</td>
										</tr>
										<tr>
											<td className="column1">Oracle email</td>
											<td className="column2">{!isAdmin ? <input type="text" placeholder="Enter email address" onChange={this.onChangeUpdateParam.bind(this, 'oracleEmailForm')} name="oracleEmail" value={this.state.oracleEmailForm.params.oracleEmail} className={this.state.oracleEmailForm.error.oracleEmailError} /> : this.state.oracleEmailForm.params.oracleEmail}</td>
											<td className="column3"></td>
											<td className="column4">{!isAdmin && <input type="button" onClick={this.handleUpdate.bind(this, 'oracleEmailForm')} className="blueButton" defaultValue="Update"/>}</td>
										</tr>
										<tr>
											<td className="column1">Customernet email</td>
											<td className="column2">{!isAdmin ? <input type="text" placeholder="Enter email address" onChange={this.onChangeUpdateParam.bind(this, 'userDetailsEmailForm')} name="userDetailsEmail" value={this.state.userDetailsEmailForm.params.userDetailsEmail} className={this.state.userDetailsEmailForm.error.userDetailsEmailError}/> : this.state.userDetailsEmailForm.params.userDetailsEmail}</td>
											<td className="column3"></td>
											<td className="column4">{!isAdmin && <input type="button" onClick={this.handleUpdate.bind(this, 'userDetailsEmailForm')} className="blueButton" defaultValue="Update" />}</td>
										</tr>
									</table>
								</p>
							</div>
				          	<div className="largePush">
				            	<h3>The phone number below is tied to this profile.</h3>
				            	<hr />
								<p className="red bold">{!this.state.showUpdatePhoneNumberOverlayDialog && this.state.phoneNumberErrorMessage}</p>
				            	<form onSubmit={this.handleUpdatePhoneNumber.bind(this)} className="updatePhoneNumberForm" name="updatePhoneNumberForm" id="updatePhoneNumberForm">
									{this.state.updatePhoneNumber.error.phoneNumberError === "error"
										?<div className="errorMessageContainer show">Please enter a valid phone number.</div>
										:null
									}
								  	<input
										value={this.state.updatePhoneNumber.params.phoneNumber}
										onBlur={this.onBlurValidatePhoneNumber.bind(this)}
										className={"phoneNumber "+this.state.updatePhoneNumber.error.phoneNumberError}
										onChange={this.setValue.bind(this, 'updatePhoneNumber', 'phoneNumber')}
										type="text"
										size={17}
										maxLength={17}
									/>
					              	&nbsp;
					              	<input type="submit" className="blueButton" value="Update Phone" />
					            </form>
				          	</div>
			          		<div className="largePush">
			            		<h3>The following account numbers are tied to this User ID.</h3>
			            		<hr />
								<table>
									<tbody>
										{approvedAccounts && approvedAccounts.slice()
											.sort(function(a, b) {
												return +a.accountNumber - +b.accountNumber;
											}).map((item, index) => {
										return (item.approvalStatus === "Deleted" || item.approvalStatus === "Rejected")?"":
										<tr key={index}>
												<td>{item.accountNumber}</td>
												<td>&nbsp;—&nbsp;</td>
											 	<td>{item.accountName} {item.admin === 'Y' ? <span className="orange">(Account Administrator)</span> : null}</td>
											</tr>
										})}
									</tbody>
								</table>
			          		</div>
			        	</div>
				        <div className="column noInnerTopMargin">
							{!isThisAccountRestricted && <div>
					          	<h2>Notification Preferences</h2>
					          	<p>View or change notification types tied to an account by selecting that account below.</p>
								<p className="bold red">{this.state.preferencesErrorMessage}</p>
					          	<form onSubmit={this.handleUpdateNotifications.bind(this)} className="updateNotificationPreferencesForm" name="updateNotificationPreferencesForm" id="updateNotificationPreferencesForm">
					            	<table className="notificationPreferencesTable checkboxTable fullWidth">
					              		<thead>
					                		<tr>
					                  			<th>Notification Type</th>
					                  			<th className="checkboxCell">
													{_.filter(this.props.state.user.notificationTypeList, ['checked', true]).length !== this.props.state.user.notificationTypeList.length
														?<a href="" onClick={this.handleSelectAllNotification.bind(this, true)} className="selectAllCheckboxesLink">Select All</a>
														:<a href="" onClick={this.handleSelectAllNotification.bind(this, false)} className="selectAllCheckboxesLink">Deselect All</a>
													}
												</th>
				                			</tr>
					              		</thead>
					              		<tbody>
											{this.props.state.user.notificationTypeList.map((item, index)=> {
												if(typeOfAccount === 'RETAIL') {
													if(item.label === 'Pricing' && !(isPricingAccess && isPriceDiscountAccess)) return null;
													if(item.label === 'Order Acknowledgement' && (
														(isPricingAccess && isPriceDiscountAccess) || isCreateOrderAccess || isEditOrderAccess
													)) {
														item.shortValue = 'ORDER ACKNOWLEDGEMENT W PRICE';
													}
													if(item.label === 'Order Acknowledgement' && !isPricingAccess && !isPriceDiscountAccess && isViewOrderAccess) {
														item.shortValue = 'ORDER ACKNOWLEDGEMENT WO PRICE';
													}
												} else if(typeOfAccount === "CONTRACT" || typeOfAccount === "PRO CHANNEL" || typeOfAccount === "HQ") {
													if(item.label === 'Pricing' && !isPricingAccess) return null;
													if(item.label === 'Order Acknowledgement' && (isPricingAccess || isCreateOrderAccess || isEditOrderAccess)) {
														item.shortValue = 'ORDER ACKNOWLEDGEMENT W PRICE';
													}
													if(item.label === 'Order Acknowledgement' && !isPricingAccess && isViewOrderAccess) {
														item.shortValue = 'ORDER ACKNOWLEDGEMENT WO PRICE';
													}
												}
												return <tr key={index}>
							                  		<td>{item.label}</td>
							                  		<td className="checkboxCell" style={{width:'27%'}}>
														<input type="checkbox" checked={item.checked} onChange={this.handleChangeNotificationType.bind(this)} name="notificationType" value={item.value} />
							                  		</td>
						                		</tr>
											})}
					              		</tbody>
					            	</table>
									<p><input className="blueButton" type="submit" value="Update Preferences" /></p>
					          	</form>
							</div>}
			        	</div>
		      		</div>
	  			:null}
				{this.state.showUpdatePhoneNumberOverlayDialog?<PhoneNumberUpdatedOverlayDialog message={this.state.phoneNumberErrorMessage} showDialog={true} />:null}
				{this.state.showUpdatePreferencesOverlayDialog?<UpdateCompleteForNotificationsOverlayDialog message={this.state.preferencesErrorMessage} showDialog={true} />:null}
				{this.state.showUpdateAccountsOverlayDialog?<UpdateCompleteForAccountAccessRequestOverlayDialog message={this.state.accountsErrorMessage} showDialog={true} />:null}
				{this.state.showEmailUpdateConfirmationDialog?<GenericOverlayDialog flag={'SavedBrochuresNotFoundOverlayDialog'} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
			</div>
        );
    }
}
const mapStateToProps = (state) => {
    return {state};
};

const mapDispatchToProps = (dispatch) => ({
	updateNotification: (data) => dispatch(updateNotification(data)),
	selectAllNotificationList: (data) => dispatch(selectAllNotificationList(data)),
	changePhoneNumber: (queryStringParams, callback) => dispatch(changePhoneNumber(queryStringParams, callback)),
	saveUserProfile: (data) => dispatch(saveUserProfile(data)),
	sendEmailSuccessDialog: (data) => dispatch(sendEmailSuccessDialog(data)),
	getUserContactPointList: (data, callback) => dispatch(getUserContactPointList(data, callback)),
	saveUserContactPointList: (data) => dispatch(saveUserContactPointList(data)),
	backupNotificationList: () => dispatch(backupNotificationList()),
	saveRoleList: (data) => dispatch(saveRoleList(data)),
	updateUserAccounts: (payload, hybridQueryParams, callback) => dispatch(updateUserAccounts(payload, hybridQueryParams, callback)),
	updateUserNotifications: (payload, hybridQueryParams, callback) => dispatch(updateUserNotifications(payload, hybridQueryParams, callback)),
	getRoleList: (payload, callback) => dispatch(getRoleList(payload, callback)),
});

OtherUserMyProfile = connect(mapStateToProps, mapDispatchToProps)(OtherUserMyProfile);
export default OtherUserMyProfile;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Profile/OtherUserMyProfile.js